import {
    createPermitExtension,
    createPermitExtensions,
    permit_extension_api_adapter,
    permit_extensions_api_adapter,
} from "permitextension/model";
import {createEntityService} from "base/entity/service";
import {AuthApiService} from "base/api/service";

const basePath = "/api/app/permitextensions";

const entityService = createEntityService(
    basePath,
    createPermitExtension,
    createPermitExtensions,
    permit_extension_api_adapter,
    permit_extensions_api_adapter
);

const PermitExtensionService = {
    getList(filter, sort, order, format = null) {
        return entityService.getList(filter, null, sort, order, null, format);
    },

    getPaginatedList(filter, page, sort, order) {
        return entityService.getList(filter, page, sort, order);
    },

    getFeatures(filter) {
        return entityService.getFeatures(filter);
    },

    getBySearchText(searchText) {
        return entityService.getBySearchText(searchText);
    },

    get(id) {
        return entityService.get(id);
    },

    create(provider) {
        return entityService.create(provider);
    },

    update(provider) {
        return entityService.update(provider);
    },

    updateStatus(id, code) {
        return AuthApiService.put(`${basePath}/${id}/status/`, code).then(response => {
            return createPermitExtension(permit_extension_api_adapter(response));
        });
    },

    download(id) {
        return AuthApiService.get(`${basePath}/${id}/printextension/`).then(
            response => {
                return response;
            }
        );
    },

    downloadInvoice(id) {
        return AuthApiService.get(`${basePath}/${id}/printinvoice/`).then(response => {
            return response;
        });
    },

    delete(id) {
        return entityService.delete(id);
    },
};

export default PermitExtensionService;
